import { MatchBuildingsDestroyedModel } from "../../../../api/repositories/stats/models/matches"
import { localize } from "../../../../common/services/localization"
import { getMinutesOrDefault } from "../../../../common/utils"
import { BuildingImage, HeroImage } from "../../ui/file-contents"
import { Table } from "../../ui/tables"

export const BuildingsDestroyedBlock: React.FC<{
    buildingsDestroyed: MatchBuildingsDestroyedModel[]
    className: string
}> = ({ buildingsDestroyed, className }) => {
    return buildingsDestroyed && buildingsDestroyed.length > 0
        ? <div className={`w-screen max-w-[650px] 2xl:w-[650px] h-[100%] flex flex-col gap-[12px] ${className} `}>
            <span className="uppercase font-semibold">
                {localize('Push history')}
            </span>
            <Table
                className="font-['Roboto']"
                headClassName="text-center text-[16px] uppercase"
                bodyClassName="text-center text-[14px]"
                cols={[
                    { headLocalName: "PUSHER", className: "pl-[24px] text-center font-normal" },
                    { headLocalName: "building", className: "text-center uppercase font-normal" },
                    { headLocalName: "PUSHED", className: "text-center font-normal" },
                    { headLocalName: "TIME", className: "text-center font-normal" },
                ]}
                rows={
                    buildingsDestroyed.map((bd, i) => ({
                        className: `${i == buildingsDestroyed.length - 1 ? '' : 'border-b-dark'}`,
                        cols: [
                            {
                                value: <div className="flex flex-col md:flex-row justify-center pl-[24px] gap-[4px]">
                                    {
                                        bd.pusherHeroes.map(((ph, i) => <HeroImage key={i} className="h-[30px] w-[55px] md:h-[40px] md:w-[68px]" size="80x47" heroName={ph} />))
                                    }
                                </div>,
                                className: 'w-[90px] text-center font-normal'
                            },
                            {
                                value: <div className="flex justify-center">
                                    <BuildingImage className="h-[30px] md:h-[40px]" type={bd.type} />
                                </div>,
                                className: ''
                            },
                            {
                                value: <div className="flex flex-col md:flex-row justify-center gap-[4px]">
                                    {
                                        bd.pushedHeroes.map(((ph, i) => <HeroImage key={i} className="h-[30px] w-[55px] md:h-[40px] md:w-[68px]" size="80x47" heroName={ph} />))
                                    }
                                </div>,
                                className: ''
                            },
                            { value: getMinutesOrDefault(bd.pushedAtSeconds), className: 'w-[90px] text-center font-normal' },
                        ],
                    }))
                }
            />
        </div>
        : null
}